import React, { useContext, useEffect, useState } from 'react';

import { navigate, RouteComponentProps } from '@reach/router';
import moment from 'moment';

import { GlobalContext } from '../../../store';

import background from '../../../assets/images/event-card-default-bg.png';
import { InnerRouter } from '../../../components/AnimatedRouter';
import { EventNavigator } from './EventNavigator';
import { TabMenu } from './TabMenu';
import { getEventField } from '../../../contrib/Utils/getEventField';
import { useGetPlayerEvent } from '../../../contrib/Hooks/useGetPlayerEvent';

export enum SECTIONS {
  'event-info',
  field,
  leaderboard
}

interface IProps extends RouteComponentProps {
  children: React.ReactChild;
  eventId: string;
}

export const EventRoot = ({ children, eventId, location }: IProps) => {
  const {
    actions: {
      events: { get: getEvent }
    }
  } = useContext(GlobalContext);

  const event = useGetPlayerEvent(eventId);

  const [currentPage, setCurrentPage] = useState('event-info');

  const groups = location ? /event\/[0-9]+\/([a-z\-]+)/g.exec(location.pathname || '') : [];

  const clubId = event && event.club ? String(event.club.id) : '0';

  useEffect(() => {
    if (event && event.rounds && event.rounds[0]) {
      navigate(`/event/${eventId}/field?section=teesheet`);
    }
  }, [event, eventId]);

  useEffect(() => {
    const newCurrentPage = groups && groups.length > 1 ? groups[1] : 'event-info';

    setCurrentPage(newCurrentPage);
  }, [groups, event]);

  useEffect(() => {
    const retriever = async () => {
      await getEvent(eventId);
    };
    retriever().catch(err => {
      throw new Error(err);
    });
  }, []);

  return event ? (
    <div className="home event-home wrapper">
      <EventNavigator previous={{ label: 'BACK TO EVENTS', to: `/club/${clubId}/events` }} />

      <div className="player-subheader-container">
        <div
          className="event-title"
          style={{
            backgroundImage: `url(${event.image ? event.image : background})`,
            backgroundPosition: '50%',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover'
          }}
        >
          <div className="bg-wrapper">
            <div className="bg-mask2" />
          </div>

          <div className="title-container">
            <h2>{event.name}</h2>
            {event.club && (
              <div className="desc">
                <div>{moment(event.start).format('dddd, LL')}</div>
                <div>{`AT ${getEventField(event).name}`}</div>
              </div>
            )}
          </div>
        </div>

        <TabMenu
          eventId={eventId}
          clubId={event && event.club ? String(event.club.id) : '0'}
          selected={Number(SECTIONS[currentPage as any])}
          sections={SECTIONS}
        />

        <InnerRouter location={location}>{children}</InnerRouter>
      </div>
    </div>
  ) : (
    <> </>
  );
};
